import React, {useEffect} from 'react';
import MobileSorter from "./MobileSorter";
import MobileCurrencySelect from "./MobileCurrencySelect";
import MobileMenuOverlay from "./MobileMenuOverlay";
import MobileLanguageSwitcher from "./MobileLanguageSwitcher";
import MobileMyTicketsMenu from "./MobileMyTicketsMenu";
import MobileLoginActive from "./MobileLoginActive";
import MobilePassengerPicker from "./MobilePassengerPicker";
import MobileDatePicker from "./MobileDatePicker";
import MobileStationInputContainer from "./MobileStationInputContainer";
import MobileFilters from "./MobileFilters";
import MobileAmenityOverlay from "@MobileOverlays/features/amenityOverlay/components/MobileAmenityOverlay";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useBlocker} from "react-router";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import {dismissAllOverlays} from "@Reducers/mobileSlice";

function MobileOverlayContainer() {
    const {
        sorterActive,
        currencySelectActive,
        mobileMenuActive,
        mobileLanguagesActive,
        mobileMyTicketsActive,
        mobileLogInActive,
        mobilePassengerPickerActive,
        singleCalendarActive,
        returnCalendarActive,
        departureStationInputActive,
        destinationStationInputActive,
        filtersOverlayActive,
        mobileAmenityGroupKey,
    } = useAppSelector((state) => state?.mobile)

    const blocker = useBlocker(true)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (blocker.state === "blocked") {
            dispatch(dismissAllOverlays())
        }
    }, [blocker])

    const mobileOverlays = {
        [`${sorterActive}`]: <MobileSorter/>,
        [`${currencySelectActive}`]: <MobileCurrencySelect/>,
        [`${mobileMenuActive}`]: <MobileMenuOverlay/>,
        [`${mobileLanguagesActive}`]: <MobileLanguageSwitcher/>,
        [`${mobileMyTicketsActive}`]: <MobileMyTicketsMenu/>,
        [`${mobileLogInActive}`]: <MobileLoginActive/>,
        [`${mobilePassengerPickerActive}`]: <MobilePassengerPicker/>,
        [`${singleCalendarActive || returnCalendarActive}`]: <MobileDatePicker/>,
        [`${departureStationInputActive || destinationStationInputActive}`]: <MobileStationInputContainer/>,
        [`${filtersOverlayActive}`]: <MobileFilters/>,
        [`${!!mobileAmenityGroupKey}`]: <MobileAmenityOverlay/>,
    }

    return mobileOverlays.true
}

export default MobileOverlayContainer;